import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-slate-300 relative bottom-0'>
      <div className='container w-full mx-auto py-6'>
        <p className='text-center text-sm font-bold' title="Youtube channel">Dynamic Footer Section</p>
      </div>
    </footer>
  )
}

export default Footer